export const footerSections = [
  {
    heading: "Categories",
    links: [
      // { href: "/pricing", label: "Pricing Plans" },
      { href: "/our-services", label: "Our Services" },
      { href: "/about-us", label: "About Us" },
      { href: "/contact-us", label: "Contact Us" },
    ],
  },
  {
    heading: "Our Company",
    links: [
      { href: "#modalLogin", label: "Sell Property" },
      { href: "#modalLogin", label: "Rent Property" },
      { href: "/", label: "Buy Property" },
      // { href: "/topmap-grid", label: "Our Agents" },
    ],
  },
];
